import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';
/**
 * The edit-mode chrome for a Reference-shaped node inspector. Owns the Back
 * button + title row + optional sticky footer; the host passes the edit form
 * in as children.
 */
export function ReferenceEditShell({ onBack, onBeforeBack, backDisabled, bodyPadding = '', children, footer, }) {
    const handleBack = () => {
        if (onBeforeBack && !onBeforeBack())
            return;
        onBack();
    };
    return (_jsxs("div", { className: "flex min-h-full flex-col", children: [_jsxs("div", { className: `flex-1 ${bodyPadding}`, children: [_jsxs(Button, { type: "button", size: "sm", variant: "ghost", className: "-ml-2 h-7 gap-1 text-xs", onClick: handleBack, disabled: backDisabled, children: [_jsx(ChevronLeft, { className: "h-3.5 w-3.5" }), "Back"] }), _jsx("div", { className: "mt-3", children: children })] }), footer && (_jsx("div", { className: "sticky bottom-0 shrink-0 flex items-center justify-end border-t border-border/60 bg-background/10 px-4 py-3 backdrop-blur-sm backdrop-saturate-150", children: footer }))] }));
}
//# sourceMappingURL=ReferenceEditShell.js.map